import React, {
    useRef, 
    useState, 
    useEffect,
    useCallback, 
} from 'react'
import { Input, Button, Message } from 'semantic-ui-react'
import axios from 'axios';

import { StyledSearch, InputWrapper } from './style';
import Services from './Services';

const debounce = (callback, wait) => {
    let timeout;
    return (...args) => {
      const context = this;
      clearTimeout(timeout);
      timeout = setTimeout(() => callback.apply(context, args), wait);
    };
}

interface Org {
    orgId: number
    name: string
    orgType: 'vuz' | 'ssuz'
    trialActs: {
        [key: string]: boolean
    }
}

interface Response {
    message: Org[]
    status: number
    error: any
}

const FromAccess = () => {
    const domen = location.host.split('.').at(-1)
    const [options, setOptions] = useState<any>([])
    const [selectedOrg, setSelectedOrg] = useState<null | Org | undefined>(null)
    const [selectedService, setSelectedService] = useState<any>(null)
    const [error, setError] = useState<any>(null);
    const [success, setSuccess] = useState(false)
    const orgs = useRef<Org[]>([])

    /**
     * добавил стиль чтобы при фокусе выбранный текст был серым, чтобы пользователь понимал что можно вводить,
     * для этого надо чтобы input терял фокус после выбора
     */
    useEffect(() => {
        document.querySelector<HTMLElement>('input.search')?.blur()
    }, [selectedOrg])

    const checkAvailability = (available) => {
        if (typeof available != 'undefined' && available) setError(null)
        else setError({type: 'service', text: 'Ваша образовательная организация уже активно использует выбранный сервис. Пожалуйста, обратитесь за консультацией к специалистам портала по телефону 8 (8362) 64-16-88.'})
    }

    const handleSelect = (e, data) => {
        const {value} = data
        const org = orgs.current[value]!;

        setSelectedOrg(org)
        setSelectedService(null)
        setSuccess(false)
        setError(null)
    }
    const handleSelectService = (e, data) => {
        const {value} = data;
        if (selectedOrg) {
            const available = selectedOrg.trialActs[value]
            checkAvailability(available)
        }
        setSelectedService(value)
    }

    const handleSearch = useCallback(debounce((e, {searchQuery}) => {
        if (!searchQuery) {
            setOptions([])
            return
        }
        axios.get<Response>(`//mypage.i-exam.${domen}/api/v2/public/orgs/search/quick?searchString=${searchQuery}&trial=${1}`)
        .then((response) => {
            if (!response.data.status) {
                const {data: { message }} = response;
                orgs.current = message

                setOptions(message.map((org, index) => ({
                    key: org.orgId,
                    text: org.name,
                    value: index,
                    // ...org
                })))
            } else {
                orgs.current = []
            }
        })
    }, 300), [])

    const handleSubmit = async(e) => {
        e.preventDefault()
        const formData = new FormData(e.target)
        const fieldValues = Object.fromEntries<any>(formData.entries())
        fieldValues['orgId'] = selectedOrg?.orgId as any
        fieldValues['actModes'] = [fieldValues.actMods]

        try {
            const {data} = await axios.post(`//mypage.i-exam.${domen}/api/v2/public/trial`, fieldValues)
            if (!data.status) {
                setError(null)
                setSuccess(true)
                global.ym && global.ym(4897120, 'reachGoal', 'send_free_access_form')
            } else {
                setError({type: 'request', text: data.error[0].text})
            }
        } catch (error) {
            setError({type: 'request', text: 'Произошла ошибка при регистрации. Пожалуйста, попробуйте повторить попытку позже.'})
            throw error
        }

    }

    return (
        <form onSubmit={handleSubmit}>
            <p style={{textAlign: 'center'}}>Бесплатный доступ <br /> к сервису независимой оценки</p>
            <StyledSearch
                selection
                fluid
                icon="dropdown"
                search={(o) => o}
                style={{marginBottom: '20px', fontSize: '.85rem'}}
                placeholder="Наименование образовательной организации"
                closeOnBlur
                minCharacters={3}
                noResultsMessage="Нет совпадений"
                selectOnNavigation={false}
                // value={value}
                onSearchChange={handleSearch}
                options={options}
                onChange={handleSelect}
                id='test'
            />
            <div style={{marginBottom: '10px'}}>Выберите сервис:</div>
            <Services
                handleSelectService={handleSelectService}
                selectedOrg={selectedOrg}
                selectedService={selectedService}
            />
            {selectedService && selectedOrg && (!error || error.type != 'service') &&
                <>
                    <InputWrapper>
                        <Input placeholder='Ваши ФИО*' required name='contactName' fluid />
                        <Input placeholder='Должность*' required name='contactPosition' fluid />
                        <Input placeholder='Email*' required name='contactEmail' fluid />
                        <Input placeholder='Контактный телефон' type='tel' name='contactPhone' fluid />
                    </InputWrapper>
                    {!success && <div style={{textAlign: 'center'}}><Button content='Отправить запрос' type='submit' positive style={{fontSize: '.85rem'}} /></div>}
                </>
            }
            {!!error &&
                <Message error style={{fontSize: '.8em'}}>
                    {error.text}
                </Message>
            }
            {success &&
                <Message success style={{fontSize: '.8em'}}>
                    Личный кабинет образовательной организации сформирован. Логин и пароль для входа в него высланы на указанную Вами электронную почту.
                </Message>
            }
        </form>
    );
}

export default FromAccess;2
